module.exports = __webpack_public_path__ + "static/assets/057764e89e0559c57c74a71b26bd2d4f.svg";